import styled from 'styled-components';

export const HighlightTableWrapper = styled.div`
  border-left: 2px solid;
  border-right: 2px solid;
  border-bottom: 2px solid;
  border-color: ${props => props.theme.colors.highlightColor};
  margin-bottom: 30px;
  margin-left: 15px;
  margin-right: 15px;
`;

export const HighlightTableMessage = styled.div`
  background-color: ${props => props.theme.colors.highlightColor};;
  padding: 5px;
`;
